export const TAB_LINKS = [
  {
    id: 'goods-description',
    label: '상품 정보',
  },
  {
    id: 'purchase-guide',
    label: '구매 안내',
  },
  {
    id: 'comments',
    label: '댓글',
  },
];

export const CLASS_TAB_LINKS = [
  {
    id: 'goods-description',
    label: '강의 소개',
  },
  {
    id: 'class-contents',
    label: '클래스',
  },
  {
    id: 'purchase-guide',
    label: '구매 안내',
  },
];

export const GACHA_STOCK_TAB_LINKS = [
  {
    id: 'introduce',
    label: '가챠 소개',
  },
  {
    id: 'ranking',
    label: '가챠 랭킹',
  },
  {
    id: 'probability',
    label: '확률 정보',
  },
  {
    id: 'notice',
    label: '유의사항',
  },
];
